"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.artifactType = exports.NodeConfigSchema = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const types_1 = require("../../uiNodes/tapes/raw-supplemental-tape/types");
const v4_1 = require("zod/v4");
exports.NodeConfigSchema = types_1.IntermediateRecordConfigSchema;
exports.artifactType = 'rawSupplementalTape';
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    type: v4_1.z.literal(exports.artifactType),
    externalFilename: v4_1.z.string(),
    loanProductSlug: v4_1.z.string().nullable(),
    creditFacilitySlug: v4_1.z.string().nullable(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map